module.exports = __webpack_public_path__ + "static/media/replaced.520323d1.png";